import { BtnLoader } from "./BtnLoader"

export const LoadingPage = () => {
    return (
        <>
            <div className="fixed left-0 right-0 top-0 bottom-0 bg-trade-50 flex flex-col items-center justify-center z-[100000]">
                <img src="/assets/layout/logo.png" className="w-[150px] mb-5" alt="logo" />
                <BtnLoader />
            </div>
        </>
    )
}